import { Vector2 } from "three";
import { MathX } from "../../math/MathX";

export class QuantizationRanges
{
  start:Vector2;
  end:Vector2;  
  num:Vector2;
  spacing:Vector2;

  getQuantizedX( x:number )
  {
    return ( x / this.spacing.x );
  }

  isInPatternX( x:number, patternSize:number, target:number )
  {
    let q = Math.floor( this.getQuantizedX( x ) ) % patternSize;
    return q === target;
  }

  getQuantizedY( y:number )
  {
    return ( y / this.spacing.y );
  }

  isInPatternY( y:number, patternSize:number, target:number )
  {
    let q = Math.floor( this.getQuantizedY( y ) ) % patternSize;
    return q === target;
  }
  
  getX( index:number )
  {
    return this.start.x + index * this.spacing.x;
  }

  getY( index:number )
  {
    return this.start.y + index * this.spacing.y;
  }

  get( index:number, out:Vector2 )
  {
    out.copy( this.spacing );
    out.multiplyScalar( index );
    out.add( this.start );
  }
}

export class QuantizationHelper
{
  static getRanges( min:Vector2, max:Vector2, spacing:Vector2 )
  { 
    let ranges = new QuantizationRanges();

    let xStart = MathX.quantizeFloored( min.x, spacing.x );
    let yStart = MathX.quantizeFloored( min.y, spacing.y );

    let xEnd = MathX.quantizeCeiled( max.x, spacing.x );
    let yEnd = MathX.quantizeCeiled( max.y, spacing.y );

    let numX = Math.ceil( 1 + ( xEnd - xStart ) / spacing.x ); 
    let numY = Math.ceil( 1 + ( yEnd - yStart ) / spacing.y );


    ranges.start = new Vector2( xStart, yStart );
    ranges.end   = new Vector2( xEnd, yEnd );
    ranges.num   = new Vector2( numX, numY );
    ranges.spacing = spacing;    
    
    return ranges;
  }
}